import * as Yup from 'yup';

/**
 * 代客泊车详情
 */
export interface ParkingDetailInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 预约时间
   */
  number?: string;
  /**
   * 车牌号
   */
  content?: string;
  /**
   * 入场时间
   */
  write_off_time?: string;
}

/**
 * 代客泊车详情表单默认值
 */
export const defaultDetailInfo: ParkingDetailInfo = {
  remark: '',
  number: '',
  content: '',
  write_off_time: '',
};

/**
 * 代客泊车详情表单校验
 */
export const parkingSchema = Yup.object().shape(
  {
    content: Yup.string().ensure().required('请输入车牌号').min(7, '车牌号至少7位字符').max(8, '车牌号至多8位字符'),
  }
);